import { Component } from "react"
import { Grid } from "@mui/material"
import { Text } from "components/texts"
import { Input } from "components/forms/components"
import { CursoEscolarSelect } from "components/forms/components/Select/custom"

export default class ClasesParticularesProfesoresTemplate extends Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)
  }


  /**
   * Render
   *
   * @returns {Component}
   */
  render() {
    const { register, errors, setValue } = this.props
    return (
      <>
        <Grid container mt={2} mb={1}>
          <Text fontWeight={"bold"}>Según datos de:</Text>
          <br />
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Input label="Nombre" width={"100%"} name={"nombre_profesor"} register={register} errors={errors} uppercase />
          </Grid>

          <Grid item xs={6}>
            <Input label="Primer apellido" width={"100%"} name={"apellido1_profesor"} register={register} errors={errors} uppercase />
          </Grid>

          <Grid item xs={6}>
            <Input label="Segundo apellido" width={"100%"} name={"apellido2_profesor"} register={register} errors={errors} uppercase />
          </Grid>

          <Grid item xs={6}>
            <CursoEscolarSelect name={"curso_escolar_id"} wantToReset={this.props.reset} register={register} errors={errors} defaultValue={null} setValue={setValue} searcheable />
          </Grid>
        </Grid>
      </>
    )
  }
}
